"use client";
import { jsx } from "react/jsx-runtime";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { ProductTileCarouselClient } from "../ProductTileCarousel/ProductTileCarouselClient.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { PRODUCT_TILE_CAROUSEL_CONTAINER, AD_TYPE_HALF } from "./constants.js";
const AdButlerProductTileCarousel = ({
  componentType,
  entry,
  locale,
  titleProps,
  itemNumbers,
  maxSlidesBySize
}) => {
  const maxItemsPerSlide = componentType === AD_TYPE_HALF ? 3 : 5;
  if (!entry || (itemNumbers == null ? void 0 : itemNumbers.length) === 0) {
    return null;
  }
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = entry.product_display_style;
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        maxWidth: `calc(100% - ${SpaceLg})`
      },
      "data-testid": PRODUCT_TILE_CAROUSEL_CONTAINER,
      children: /* @__PURE__ */ jsx(
        ProductTileCarouselClient,
        {
          componentType,
          inventoryAware: inventory_aware_listings,
          itemNumbers,
          locale,
          maxItemsPerSlide,
          showActionButton: show_action_button,
          showReviews: show_reviews,
          testId: "AdButler_Products",
          titleProps,
          variant: product_card_display_style,
          maxSlidesBySize,
          product_tile_data_source
        }
      )
    }
  );
};
export {
  AdButlerProductTileCarousel
};
